/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';

// Counter Setup
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

// Bootstrap Imports
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

const Counters = () => {
	// Component Functions
	const stadistics = [
		{ count: 25, title: 'Proyectos Completados' },
		{ count: 13, title: 'Proyectos En Ejecución' },
		{ count: 98, title: 'Porcentaje de Éxito' },
	];

	return (
		<Container className='my-4'>
			<Row className='py-0 py-md-5'>
				{stadistics.map((value, i) => (
					<CountUp key={i} end={value.count} redraw={true}>
						{({ countUpRef, start }) => (
							<VisibilitySensor
								onChange={start}
								delayedCall
								partialVisibility='bottom'
								offset={{ bottom: -150 }}>
								<Col xs={12} md={4} className={i < 2 && 'mb-4 mb-md-0'}>
									<Card className='counter-card'>
										<Card.Body className='py-4'>
											<div
												className='d-flex justify-content-center'
												style={{ width: '100%' }}>
												<h1
													style={{ color: '#540963', fontWeight: 600 }}
													ref={countUpRef}
												/>
												{value.title === 'Porcentaje de Éxito' && (
													<h1 style={{ color: '#540963', fontWeight: 600 }}>
														%
													</h1>
												)}
											</div>

											<p style={{ fontWeight: 500 }}>{value.title}</p>
										</Card.Body>
									</Card>
								</Col>
							</VisibilitySensor>
						)}
					</CountUp>
				))}
			</Row>
		</Container>
	);
};

export default Counters;
